import { useEffect, useState } from "react";
import api, { formatErr } from "@/lib/api";
import { PageHeader, Section } from "@/components/Shared";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Trash } from "@phosphor-icons/react";

const CALC_TYPES = ["Fixed", "Percent of Basic", "Percent of Gross", "Per Day", "Per Hour", "Variable", "Manual"];

export default function SalaryComponents() {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", type: "earning", description: "", calculation_type: "Fixed", default_amount: 0, taxable: true, active: true });

  const load = async () => {
    try { const r = await api.get("/salary-components"); setList(r.data); } catch (e) { toast.error(formatErr(e)); }
  };
  useEffect(() => { load(); }, []);

  const save = async () => {
    try { await api.post("/salary-components", form); toast.success("Added"); setOpen(false); setForm({ ...form, name: "" }); load(); }
    catch (e) { toast.error(formatErr(e)); }
  };
  const del = async (id) => { await api.delete(`/salary-components/${id}`); load(); };

  return (
    <div data-testid="admin-components">
      <PageHeader overline="Compensation" title="Salary Components"
        actions={
          <Dialog open={open} onOpenChange={setOpen}>
            <DialogTrigger asChild>
              <Button className="rounded-none bg-[#FF5500] hover:bg-[#E64D00] text-white" data-testid="new-component">+ New Component</Button>
            </DialogTrigger>
            <DialogContent className="rounded-none">
              <DialogHeader><DialogTitle className="font-head">New Component</DialogTitle></DialogHeader>
              <div className="space-y-3">
                <Input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="rounded-none" data-testid="comp-name" />
                <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className="w-full h-10 border border-[#E5E5E5] px-2 bg-white">
                  <option value="earning">Earning</option><option value="deduction">Deduction</option>
                </select>
                <select value={form.calculation_type} onChange={(e) => setForm({ ...form, calculation_type: e.target.value })} className="w-full h-10 border border-[#E5E5E5] px-2 bg-white">
                  {CALC_TYPES.map((t) => <option key={t}>{t}</option>)}
                </select>
                <Input type="number" placeholder="Default amount" value={form.default_amount} onChange={(e) => setForm({ ...form, default_amount: parseFloat(e.target.value) || 0 })} className="rounded-none" />
                <Input placeholder="Description" value={form.description} onChange={(e) => setForm({ ...form, description: e.target.value })} className="rounded-none" />
                <label className="flex items-center gap-2 text-sm"><input type="checkbox" checked={form.taxable} onChange={(e) => setForm({ ...form, taxable: e.target.checked })} /> Taxable</label>
                <Button onClick={save} className="w-full rounded-none bg-[#FF5500]" data-testid="save-component">Save</Button>
              </div>
            </DialogContent>
          </Dialog>
        } />
      <Section title={`${list.length} components`}>
        <table className="w-full table-dense">
          <thead>
            <tr className="border-b-2 border-[#1F4E8C] text-left">
              <th className="eyebrow">Name</th><th className="eyebrow">Type</th>
              <th className="eyebrow">Calculation</th><th className="eyebrow">Default ₹</th>
              <th className="eyebrow">Taxable</th><th />
            </tr>
          </thead>
          <tbody>
            {list.map((c) => (
              <tr key={c.id} className="border-b border-[#F0F0EE]">
                <td className="font-medium">{c.name}</td>
                <td className="capitalize">{c.type}</td>
                <td>{c.calculation_type}</td>
                <td>₹{c.default_amount?.toLocaleString()}</td>
                <td>{c.taxable ? "Yes" : "No"}</td>
                <td><button onClick={() => del(c.id)} className="text-neutral-500 hover:text-red-600"><Trash size={14} /></button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </Section>
    </div>
  );
}
